export default __webpack_public_path__ + "static/media/siges.ecd4b880.jpg";